import React, { useState } from "react";
import { api } from "@/lib/api";

const Appointment = () => {
  const [form, setForm] = useState({ client_name: "", client_email: "", client_phone: "", date: "", subject: "Property Consultation", notes: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/public/appointment", form);
      setSent(true);
      setForm({ client_name: "", client_email: "", client_phone: "", date: "", subject: "Property Consultation", notes: "" });
    } catch {}
  };
  return (
    <div data-testid="appointment-page">
      <section className="bg-navy text-white py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="overline text-gold">Book</div>
          <h1 className="font-display text-4xl lg:text-6xl mt-4">Book a Consultation</h1>
          <p className="mt-4 max-w-xl text-white/70">30-minute private consultation with a senior Forte advisor.</p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
        {sent ? (
          <div className="bg-slate-50 border border-gold p-10 text-center" data-testid="apt-success">
            <div className="overline text-gold">Received</div>
            <h2 className="font-display text-3xl text-navy mt-3">Your request is in.</h2>
            <p className="mt-4 text-slate-600">We'll confirm your appointment via email within 2 business hours.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-slate-200 p-8 lg:p-10 space-y-4" data-testid="appointment-form">
            <div className="grid md:grid-cols-2 gap-4">
              <input required placeholder="Full name" value={form.client_name} onChange={(e) => setForm({ ...form, client_name: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="apt-name" />
              <input required type="email" placeholder="Email" value={form.client_email} onChange={(e) => setForm({ ...form, client_email: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="apt-email" />
            </div>
            <input placeholder="Phone" value={form.client_phone} onChange={(e) => setForm({ ...form, client_phone: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="apt-phone" />
            <div className="grid md:grid-cols-2 gap-4">
              <input required type="datetime-local" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="apt-date" />
              <select value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold bg-white" data-testid="apt-subject">
                <option>Property Consultation</option><option>Home Valuation</option><option>Commercial Advisory</option><option>Dental Practice (Confidential)</option><option>Medical Clinic (Confidential)</option>
              </select>
            </div>
            <textarea rows="4" placeholder="What would you like to discuss?" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="apt-notes" />
            <button className="btn-navy w-full" data-testid="apt-submit">Request Appointment</button>
          </form>
        )}
      </section>
    </div>
  );
};

export default Appointment;
